
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --container-max-content-width:1660px;
  --container-padding:var(--space-s-4xl);

  width:100%;
  display:block;
  margin-right:auto;
  margin-left:auto;
  margin-bottom:0px;

  padding-right:var(--container-padding);
  padding-left:var(--container-padding);
  max-width:calc(
    var(--container-max-content-width) + 2 * var(--container-padding)
  );
}
`;